import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import { sepratePriceFromComma } from "common/method/seprateNumberFromComma";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpModalOfflineOrder from "../otpModal";

import { dateConvertMiladiToShamsi } from "common/method/date";
import { actionTypes } from "redux/offlineorder/select_offline_orders";
import { delete_offline_order } from "redux/offlineorder/delete_offline_order_otp";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "common/method/handleNotificationAlert";
import NoData from "common/components/MuiDataGrid/components/noData/NoData";

const CurrentOfflineList = () => {
  const reducerData = useSelector((state) => state.selectOfflineOrdersReducer);
  const [isOtpModalOpen, setOtpModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [confirmAnchor, setConfirmAnchor] = useState(null);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const [loadingItems, setLoadingItems] = useState({});
  let dispatch = useDispatch();

  const handleSubmitOrders = () => {
    setOtpModalOpen(true);
  };

  useEffect(() => {
    dispatch({
      type: actionTypes.selectOfflineOrdersAsync,
      payload: { data: { state: -1 } },
    });
  }, []);

  const order = reducerData?.data?.results;

  const handleSelectItem = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      const allIds = order.map((item) => item?.id);
      setSelectedItems(allIds);
    }
    setSelectAll(!selectAll);
  };

  const handleRemoveOrder = (id) => {
    const data = {
      _id: [id],
    };
    setLoadingItems((prev) => ({ ...prev, [id]: true }));
    delete_offline_order(data)
      .then((res) => {
        const isOk = handleNotificationAlertTryUpdate(res);

        if (isOk) {
          dispatch({
            type: actionTypes.selectOfflineOrdersAsync,
            payload: { data: { state: -1 } },
          });
        }
      })

      .catch((error) => {
        handleNotificationAlertCatch();
      })
      .finally(() => {
        setLoadingItems((prev) => ({ ...prev, [id]: false }));
      });
  };

  const Field = ({ label, value }) => (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={500}>
        {value || "-"}
      </Typography>
    </Box>
  );

  if (reducerData?.loading) {
    return (
      <Grid
        container
        spacing={2}
        sx={{ marginBlock: 2, maxHeight: 400, overflow: "auto" }}
      >
        {" "}
        <Grid item xs={12}>
          <CircularProgress size={36} />{" "}
        </Grid>
      </Grid>
    );
  }
  return (
    <>
      <Typography> سفارشات فعال </Typography>
      <Grid container spacing={2} sx={{ maxHeight: 500, overflow: "auto" }}>
        {/* {order?.length > 0 && (
          <Grid item xs={12}>
            <Checkbox
              checked={selectAll}
              onChange={handleSelectAll}
              color="primary"
            />
            انتخاب همه
            {selectedItems.length > 0 &&
              ` (${selectedItems.length} آیتم انتخاب‌ شده)`}
          </Grid>
        )} */}
        {order?.length > 0 ? (
          order?.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  p: 2,
                  backgroundColor: item?.body?.has_error
                    ? "#ffebee"
                    : "#fafafa",
                  position: "relative",
                }}
              >
                <IconButton
                  color="error"
                  size="small"
                  onClick={(e) => {
                    setConfirmAnchor(e.currentTarget);
                    setSelectedDeleteId(item?.id);
                  }}
                  disabled={!!loadingItems[item?.id]}
                  sx={{
                    position: "absolute",
                    top: { xs: 12, md: 24 },
                    right: 8,
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>

                <Grid container spacing={2} alignItems="center">
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2}
                    display="flex"
                    alignItems="center"
                  >
                    {/* <Checkbox
                      sx={{ p: 0, mr: 1 }}
                      checked={selectedItems.includes(item?.id)}
                      onChange={() => handleSelectItem(item?.id)}
                    /> */}
                    {index + 1} - {item?.body?.symbol || "-"}
                  </Grid>
                  <Grid item xs={6} sm={6} md={1}>
                    <Field
                      label="قیمت"
                      value={sepratePriceFromComma(item?.body?.price)}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={1}>
                    <Field
                      label="تعداد"
                      value={sepratePriceFromComma(item?.body?.quantity)}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={2}>
                    <Field
                      label="ارزش کل"
                      value={sepratePriceFromComma(item?.body?.order_value)}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={1}>
                    <Field
                      label="نوع"
                      value={item?.body?.side === "BUY" ? "خرید" : "فروش"}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={2}>
                    <Field
                      label="تاریخ"
                      value={
                        item?.body?.trigger_datetime
                          ? dateConvertMiladiToShamsi(
                              item?.body?.trigger_datetime,
                            )
                          : "نامشخص"
                      }
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2}>
                    <Field
                      label="وضعیت"
                      value={
                        item?.body?.trigger_datetime
                          ? item?.body?.description
                          : "نامشخص"
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ))
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <NoData content={"در حال حاضر سفارش آفلاینی ثبت نشده است."} />
          </Box>
        )}
      </Grid>

      {/* {order?.length > 0 && (
        <Button
          variant="contained"
          color="secondary"
          sx={{ marginTop: 2 }}
          onClick={handleSubmitOrders}
          disabled={selectedItems?.length <= 0}
        >
          ارسال سفارش‌ها
        </Button>
      )} */}
      {/* OTP Modal */}
      {/* todo */}
      <OtpModalOfflineOrder
        isOtpModalOpen={isOtpModalOpen}
        setOtpModalOpen={setOtpModalOpen}
        selectedItems={selectedItems}
      />
      <Popover
        open={Boolean(confirmAnchor)}
        anchorEl={confirmAnchor}
        onClose={() => setConfirmAnchor(null)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        sx={{
          ml: 0.5,
        }}
      >
        <Box sx={{ p: 2, maxWidth: 220 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            آیا از حذف این سفارش مطمئن هستید؟
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button size="small" onClick={() => setConfirmAnchor(null)}>
              انصراف
            </Button>

            <Button
              size="small"
              color="error"
              variant="contained"
              onClick={() => {
                handleRemoveOrder(selectedDeleteId);
                setConfirmAnchor(null);
              }}
            >
              حذف
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default CurrentOfflineList;
